/**
 * Gets the collaborate url from window.ATARIM if on /collaborate
 * Otherwise returns the page url with protocol
 *
 * NOTE: Returns the full URL including the https:// prefix
 */
export const collaborateUrl = (): string => {
  if (window.ATARIM) {
    // Assuming ATARIM.host doesn't include protocol
    return `https://${window.ATARIM.host}`;
  } else {
    // Return full URL including protocol
    return `${window.location.protocol}//${window.location.host}`;
  }
};

export const getCurrentPageUrl = () => {
  const url = window.location.href;
  const urlObj = new URL(url);
  const baseUrl = `${urlObj.origin}${urlObj.pathname}`;
  return baseUrl;
};
